import { z } from 'zod';

export const callDetailSchema = z.object({
  sid: z.string(),
  to: z.string(),
  direction: z.string(),
  status: z.string(),
  duration: z.number(),
  cost: z.number(),
  startTime: z.string().datetime(),
});

export const twilioCostsSummarySchema = z.object({
  month: z.string().regex(/^\d{4}-\d{2}$/),
  phoneNumber: z.string(),
  callCount: z.number(),
  callMinutes: z.number(),
  callCost: z.number(),
  smsCount: z.number(),
  smsCost: z.number(),
  totalCost: z.number(),
  currency: z.string(),
  calls: z.array(callDetailSchema),
  pagination: z.object({
    page: z.number(),
    pageSize: z.number(),
    totalCalls: z.number(),
    totalPages: z.number(),
  }),
  cachedAt: z.string().datetime().optional(),
});

export const twilioCostsQuerySchema = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional(),
  day: z
    .string()
    .regex(/^\d{1,2}$/)
    .transform((val) => parseInt(val, 10))
    .optional(),
  page: z
    .string()
    .transform((val) => parseInt(val, 10))
    .optional(),
  pageSize: z
    .string()
    .transform((val) => parseInt(val, 10))
    .optional(),
  refresh: z
    .string()
    .transform((val) => val === 'true')
    .optional(),
  phoneNumber: z
    .string()
    .regex(/^\+[1-9]\d{6,14}$/, 'Must be a valid E.164 phone number')
    .optional(),
});

export type CallDetail = z.infer<typeof callDetailSchema>;
export type TwilioCostsSummary = z.infer<typeof twilioCostsSummarySchema>;
export type TwilioCostsQuery = z.infer<typeof twilioCostsQuerySchema>;
